export default __webpack_public_path__ + "static/media/09.8a00f800.jpg";